import type { ReactNode } from "react";
import { Modal } from "@rosette/web_components/src/ui/Modal.js";
import { Card } from "@rosette/web_components/src/ui/Card.js";


interface PromptPopupProps {
    children?: ReactNode;
    title?: string;
    visible: boolean;
    close: () => void;
}


export function PromptPopup({ children, title, visible, close }: PromptPopupProps) {
    return (
        <Modal className="max-w-xl" open={visible} onClose={close}>
            <Card>
                <h2>
                    {title}
                </h2>
                {children}
            </Card>
        </Modal>
    );
}
